import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary capturou um erro:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="error-boundary">
          <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center">
            <div className="h-14 w-14 rounded-2xl bg-rose-50 text-rose-600 flex items-center justify-center mx-auto mb-5">
              <AlertTriangle className="h-7 w-7" />
            </div>
            <h1 className="font-heading text-xl font-bold text-slate-900">Ops, algo deu errado</h1>
            <p className="text-sm text-slate-500 mt-2">
              Ocorreu um erro nesta tela, mas seus dados estão seguros. Você pode tentar novamente ou voltar ao início.
            </p>
            <div className="flex items-center justify-center gap-3 mt-6">
              <button
                onClick={() => window.location.reload()}
                data-testid="error-reload-button"
                className="bg-brand hover:bg-brand-hover text-white font-medium px-4 py-2.5 rounded-lg text-sm flex items-center gap-2"
              >
                <RefreshCw className="h-4 w-4" /> Recarregar
              </button>
              <a
                href="/dashboard"
                onClick={this.handleReset}
                data-testid="error-home-link"
                className="border border-slate-200 text-slate-600 font-medium px-4 py-2.5 rounded-lg text-sm flex items-center gap-2 hover:bg-slate-50"
              >
                <Home className="h-4 w-4" /> Início
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
